























































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { setHeadTags, buildHeadTags } from '../../lib/headTagCreate'

@Component
export default class Contract extends Vue {
  created() {
    setHeadTags(buildHeadTags.contract())
  }
  print() {
    window.print()
  }
}
